var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBold = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6028 9.65C13.3222 8.95 13.7694 7.95833 13.7694 6.88889C13.7694 4.75 12.0194 3 9.88056 3H5.77778C5.35 3 5 3.35 5 3.77778V10V16.2222C5 16.65 5.35 17 5.77778 17H10.8333C12.9722 17 14.7222 15.25 14.7222 13.1111C14.7222 11.6139 13.8667 10.3111 12.6028 9.65ZM6.55556 4.55556H9.88056C11.1639 4.55556 12.2139 5.60556 12.2139 6.88889C12.2139 8.17222 11.1639 9.22222 9.88056 9.22222H6.55556V4.55556ZM10.8333 15.4444H6.55556V10.7778H9.88056H10.8333C12.1167 10.7778 13.1667 11.8278 13.1667 13.1111C13.1667 14.3944 12.1167 15.4444 10.8333 15.4444Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBold, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bold.e8b1e37a.svg";
export { ForwardRef as ReactComponent };